export const financesFormikContants = {
    currentFinancesBalance: "currentFinancesBalance",
    buildingId: "buildingId",
  };
  
  export default {
    [financesFormikContants.currentFinancesBalance]: 0.00,
    [financesFormikContants.buildingId]: 1,
  };
  